import { render, staticRenderFns } from "./VisitorMachineSetting.vue?vue&type=template&id=245abc08&scoped=true&"
import script from "./VisitorMachineSetting.vue?vue&type=script&lang=js&"
export * from "./VisitorMachineSetting.vue?vue&type=script&lang=js&"
import style0 from "./VisitorMachineSetting.vue?vue&type=style&index=0&id=245abc08&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245abc08",
  null
  
)

export default component.exports